import Vue from "vue";

export function toNumber(value) {
  // if (typeof value === "string")
    // value = value.replace(",", ".");
  return Number(value);
  // if (typeof value === "number")
  //   return value;
  // if (!value || value.match(/[a-z]/i))
  //   return NaN;
  // return Number.parseFloat(value.replace(/\s+/g,"").replace(",", "."));
}

export function floatTrim(float) {
  if (typeof float !== 'number') {
    return float;
  }
  return parseFloat(float).toFixed(2)
}

const EUR_RATE = 1.95583;// 1 EUR = 1.95583 BGN

function toEuro(bgn) {
  if (typeof bgn === 'undefined') {
    return;
  }
  bgn = Number(bgn);
  const eur = bgn / EUR_RATE;
  return floatTrim(eur);
}

export function showAmount(val, eurAlso, sameLine) {
  if (val && val.amount !== undefined) {
    let d = floatTrim(val.amount);
    if (val.currency)  {
      if (val.currency.prefix)
        d = val.currency.symbol + ' ' + d;
      else
        d = d + ' ' + val.currency.symbol;
    }
    if (eurAlso && val.currency.code !== 'EUR') {
      d += sameLine ? ' / ' : '<br>';
      d += '<em>' + toEuro(val.amount) + ' &euro;</em>'
    }
    return d;
  } else {
    return val;
  }
}

export function showDualAmount(val) {
      if (!val || val === 0)
        return '0 € / 0 лв.';

      const notExpired = new Date() <= new Date('2026-08-07');
      const rate = 1.95583;
      if(typeof val === 'number') {
        const bgn = (val * rate).toFixed(2);
        const euro = val.toFixed(2);
        if (notExpired)
          return `${euro} € / ${bgn} лв.`;

        return `${euro} €`;
      }
      const amount = val.amount;
      const symbol =  val.currency.symbol;
      if (notExpired) {
        if (symbol === '€') {
          return `${amount.toFixed(2)} € / ${(amount * rate).toFixed(2)} лв.`;
        }
        else if (symbol === 'лв.') {
          return `${(amount / rate).toFixed(2)} € / ${amount.toFixed(2)} лв.`;
        }
        else {
          return `${amount.toFixed(2)} €`;
        }
      }
      return `${amount.toFixed(2)} ${symbol}`;
 }


export function getStateIcon(shipmentRoutingState) {
  let icon = "fa-bug";
  if (shipmentRoutingState && shipmentRoutingState.code) {
    let code = shipmentRoutingState.code;
    if (code === "FFFFA")
      // icon = "check_circle";
      icon = "fa-check-circle";
    else if (code.startsWith("F")) icon = "fa-check-circle";
    else if (code.startsWith("H")) icon = "fa-times-circle";
    else if (code === "CCCCL") icon = "fa-laptop";
    // else if (code.startsWith("CCCD"))
    //   icon = "input";
    // else if (code.startsWith("CCCF"))
    //   icon = "input";
    else if (code.startsWith("C"))
      // icon = "input";
      icon = "fa-sign-in-alt";
    else if (code.startsWith("DDDDA")) icon = "fa-truck";
    // icon = "local_shipping";
    else if (code.startsWith("DDDDF")) icon = "fa-shipping-fast";
    else if (code.startsWith("D")) icon = "fa-warehouse";
    else if (code.startsWith("I")) icon = "fa-exclamation-circle";
    // icon = "store_mall_directory";
    // el = Object.assign( el, { stateIcon : icon} );
  } else {
    icon = "fa-file";
  }
  return { stateIcon: icon };
}

export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export { validatePhone } from "./phone";


export function extractBodyErrorMessages(body) {
  let msg = '';
  if (body) {
    if (body.errors) {
      for (let x = 0; x < body.errors.length; x++) {
        if (msg.length > 0)
          msg = msg + ', ';
        msg = msg + body.errors[x].text;
      }
    }
    else if (body.error) {
      msg = body.error;
    }
  }
  return msg;
}

export function extractBodyErrorMessages2(body) {

  return body.errors && Array.isArray(body.errors)
    ? body.errors.map(err => err.text).join(', ')
    : '';
}


export function downloadFile(response) {
  let filename = "";
  let mime = response.headers.get("content-type") || "application/octet-stream";
  let disp = response.headers.get("content-disposition");
  if (disp && disp.indexOf("attachment") !== -1) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disp);
      if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
  }

  let blob = typeof File === "function" && !window.navigator.msSaveBlob // (2019-10-14) Gorgi: better use Blob only due to lack of (or partial) support of File by most browsers
      ? new File([response.body], filename, { type: mime })
      : new Blob([response.body], { type: mime });

  if (typeof window.navigator.msSaveBlob !== "undefined") {
    // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
    window.navigator.msSaveBlob(blob, filename);
  } else {

    let URL = window.URL || window.webkitURL;
    let downloadUrl = URL.createObjectURL(blob);
    // use HTML5 a[download] attribute to specify filename
    let a = document.createElement("a");
    // safari doesn't support this yet
    if (typeof a.download === "undefined") {

      window.location = downloadUrl;
    } else {

      a.style.display = 'none';
      a.href = downloadUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    setTimeout(() => URL.revokeObjectURL(downloadUrl), 100); // cleanup
  }
}

export function printDateTime(datetime, dateOrTime) {
  if (!datetime) return '';
  let d = new Date( datetime ),
      year  = d.getFullYear(),
      month = ('0' + (d.getMonth()+1) ).slice(-2),
      day   = ('0' + d.getDate() ).slice(-2),
      hour  = ('0' + d.getHours() ).slice(-2),
      min   = ('0' + d.getMinutes() ).slice(-2);

  if (dateOrTime && dateOrTime == 1)
    return `${year}-${month}-${day}`;
  else if (dateOrTime && dateOrTime == 2)
    return `${hour}:${min}`;
  else
    return `${year}-${month}-${day} ${hour}:${min}`;
}

export function addressString(address, t) {
  let d = {
    settlement: "",
    address: ""
  };

  if (!address || !(address.settlement && address.settlement.code))
    return d;

  if (!t) {
    this.$t = this.$t || (param => param);
    t = {
      block: this.$t("block"),
      floor: this.$t("floor"),
      entrance: this.$t("entrance"),
      apartment: this.$t("apartment")
    };
  }

  let a = "";
  if (address.country && address.country.code)
    a = "[" + address.country.code + "-";

  if (address.post_code) {
    // no country code so far? Assume default "BG"
    if (a.length === 0)
      a = "[BG-";
    a += address.post_code + "] ";
  }

  if (address.settlement && address.settlement.name)
  {
    if(address.settlement.name.startsWith(a))
      a = address.settlement.name;
    else
      a = a + address.settlement.name;
  }

  d.settlement = a;

  if (address.complex && address.complex.name)
    a = a + ", " + address.complex.name;

  if (address.street && address.street.name)
    a = a + ", " + address.street.name;

  if (address.street_number)
    a = a + " №" + address.street_number;

  if (address.block)
    a = a + ", " + t["block"] + " " + address.block;

  if (address.entrance)
    a = a + ", " + t["entrance"] + " " + address.entrance;

  if (address.floor)
    a = a + ", " + t["floor"] + " " + address.floor;

  if (address.apartment)
    a = a + ", " + t["apartment"] + " " + address.apartment;
  if (address.additional)
    a = a + ", " + address.additional;

  d.address = a;
  return d;
}

export function getDefaultServiceTypes(type) {
  return [
    {
      value: 'TARGO_ON_SITE',
      shortText: 'TS',
      allowable: true,
      intercity: true
    },
    {
      value: 'ECONOMIC',
      shortText: 'FL',
      intercity: true,
      maxDays: true
    },
    {
      value: 'EXPRESS_18',
      shortText: 'SP',
      default: true,
      cityDefault: true,
      intracity: true,
      intercity: true,
      maxDays: true
    },
    {
      value: 'EXPRESS_14',
      shortText: '14',
      allowable: true,
      intracity: true,
      intercity: true
    },
    {
      value: 'EXPRESS_12',
      shortText: '12',
      allowable: true,
      intracity: true,
      intercity: true
    },
    {
      value: 'EXPRESS_10',
      shortText: '10',
      allowable: true,
      intracity: true,
      intercity: true
    },
    {
      value: 'COURIER_CITY_150',
      shortText: 'C12',
      allowable: true,
      intracity: true
    },
    {
      value: 'COURIER_CITY_EXPRESS',
      shortText: 'C24',
      allowable: true,
      intracity: true
    },

  ];
}

export function getDefaultShipment() {
  return {
    id: 0,
    owned: true,
    accepted: false,
    collected: false,
    cancellable: false,
    manifest: "",
    reference: null,
    order_date: null,
    isCollectionDateChanged: false,
    amazon_reference: "",
    cost_center: null,
    source: {
      direct: true,
      network: false,
      after: null,
      until: null,
      access: null,
      address: {
        country: {
          code: "BG",
          name: "България"
        },
        post_code: "",
        settlement: {
          code: null,
          name: "",
          schedule: {
            courier: null,
            cargo: null
          },
          client_message: ""
        },
        complex: {
          code: null,
          name: ""
        },
        street: {
          code: null,
          name: ""
        },
        street_number: "",
        block: "",
        entrance: "",
        floor: "",
        apartment: "",
        additional: null
      },
      "geo": {
        "latitude": 0,
        "longitude": 0
      },
      "office": {
        "code" : null,
        "name" : null
      },
      "station": {
        "code": null,
        "name": null
      },
      "instructions": "",
      "partner": {
        "code": null,
        "name": ""
      },
      "contact_person": "",
      "contact_phone": "",
      "contact_email": null,
      "notification": null,
      "call_required": false,
      "extended_convey": false,
      "tail_lift": false,
      "thc": false,
      "personal_number": ""
    },
    "target": {
      "direct": true,
      "network": false,
      "after": null,
      "until": null,
      "access": null,
      "address": {
        "country": {
          "code": "BG",
          "name": "България"
        },
        "post_code": "",
        "settlement": {
          "code": null,
          "name": "",
          "schedule": {
            "courier": null,
            "cargo": null
          },
          "client_message": ""
        },
        "complex": {
          "code": null,
          "name": ""
        },
        "street": {
          "code": null,
          "name": ""
        },
        "street_number": "",
        "block": "",
        "entrance": "",
        "floor": "",
        "apartment": "",
        "additional": null
      },
      "geo": {
        "latitude": 0,
        "longitude": 0
      },
      "office": {
        "code" : null,
        "name" : null
      },
      "station": {
        "code": null,
        "name": null,
      },
      "instructions": "",
      "partner": {
        "code": null,
        "name": ""
      },
      "contact_person": "",
      "contact_phone": "",
      "contact_email": null,
      "notification": null,
      "call_required": false,
      "extended_convey": false,
      "tail_lift": false,
      "thc": false
    },
    "service": {
      "type": "",// "EXPRESS_18",
      "time": null
    },
    "type": "NETWORK",
    "description": "",
    "payment": {
      "method": "PAYED_ON_SENDING",
      "cash": false,
      "advanced": false,
      "payer": {
        "code": null,
        "name": ""
      },
      "price": {
        "calculated": {
          "amount": 0,
          "currency": {
            "code": "EUR",
            "symbol": "€",
            "prefix": true
          }
        },
        "overridden": null,
        "overridden_reason": null,
        "overridden_authorised": false,
        "taxing": {
          "exempt_id": null,
          "rate": 0.2
        },
        "price": {
          "amount": 0,
          "currency": {
            "code": "EUR",
            "symbol": "€",
            "prefix": true
          }
        },
        "price_with_tax": {
          "amount": 0,
          "currency": {
            "code": "EUR",
            "symbol": "€",
            "prefix": true
          }
        }
      }
    },
    "return_pod": false,
  //  "return_cmr": false,
    "return_doc": false,
    "return_pkg": false,
    "saturday"  : false,
    packaging_handling: null,
    packaging_stretching: false,
    cash_on_delivery: {
      cash_on_delivery: false,
      postal: false,
      paid: false,
      amount: {
        amount: 0,
        currency: {
          code: "EUR",
          symbol: "€",
          prefix: true
        }
      },
      payment_type: "BANK_TRANSFER",
      invoice_id: null
    },
    insurance: {
      active: false,
      liability: {
        amount: 0,
        currency: {
          code: "EUR",
          symbol: "€",
          prefix: true
        }
      },
      fragile: false,
      used: null
    },
    "declared_value": {
      "ignore": false,
      "amount": {
        "amount": 0,
        "currency": {
          "code": "EUR",
          "symbol": "€",
          "prefix": true
        }
      }
    },
    contents: [
      {
        id: null,
        count: 1,
        packaging: {
          code: "ST",
          name: "парче"
        },
        weight: 0,
        volume: 0,
        lademeters: 0,
        dimXEditable: true,
        dimYEditable: true,
        dimZEditable: true,
        parcel_x: 0,
        parcel_y: 0,
        parcel_z: 0,
        internal: {
          count: null,
          packaging: null
        },
        single_layer: false
      }
    ]
  };
}

function stylizeServicingSchedule(_this, arr, style) {
  arr = [...arr];
  arr.unshift( arr.pop() );// Shifts response array to *sync* with translation indexes - backend responds MON as first-day-of-week (index-0), while translation $t('dayOfWeek.0') is SUN
  arr = arr.map((value, index) => {
    let html = _this.$t("dayOfWeek." + index + ".two");
    html = `<span class="text-uppercase ${value ? (style || 'font-weight-black success--text') : 'grey--text text--lighten-1' }">${ html }</span>`;
    return html;
  });
  arr.push( arr.shift() );// Shifts days back to *render* MON as first-day-of-week
  return arr.join(" ");
}

/**
 * Renders and styles the DOM
 * @param {Vue} _this this Vue instance
 * @param {Object} data {servicing: {cargo:{type, (week_days|max_days)}, courier:{type, (week_days|max_days)}}, isCourier}
 * @param {String} ref ref of the target Vue component instance
 * @param {String} style CSS classes
 * @returns void
 */
export function postProcessMessageDOM(_this, data, ref, style) {
  let sugg = _this.$refs[ ref || "suggester_settlement" ];
  if (!sugg) {
    return;
  }

  let elem = sugg.$el.querySelector(".v-messages__message");
  if (!elem) {
    return;
  }

  let html = "<div style=\"font-size: 11px\">";

  if (_this.address && _this.address.trim()) {
    html += "<div>" + _this.address + "</div>";
  }

  let cargoDisplay = "";
  let courierDisplay = "";

  if (!!data.servicing) {
    cargoDisplay = generateScheduleDisplay(_this, data.servicing.cargo, style);
    courierDisplay = generateScheduleDisplay(_this, data.servicing.courier, style);
  }

  if (!!cargoDisplay)
    html += "<div>" + _this.$t("Cargo"  ) + ": " + cargoDisplay + "</div>";
  if (!!courierDisplay)
    html += "<div>" + _this.$t("Courier") + ": " + courierDisplay + "</div>";
  html += "</div>";
  elem.innerHTML = html;
}

function generateScheduleDisplay(_this, schedule, style) {
  if (!schedule || !schedule.type)
    return "";
  if (schedule.type === "max_days" && !!schedule.max_days)
    return _this.$t('Up to N working days', [schedule.max_days]);
  if (schedule.type === "week_days" && !!schedule.week_days && schedule.week_days.length > 0)
    return stylizeServicingSchedule(_this, schedule.week_days, style);
  return "";
}

export function versionInfo(_this, full) {
  return _this.$t('Version') + " " + process.env.VUE_APP_VERSION + " #" + process.env.VUE_APP_GIT_COMMIT_ID + " " + process.env.VUE_APP_GIT_COMMIT_DATE + (full ? " © " + new Date().getFullYear() + ' <a href="https://www.prolet.bg">' + _this.$t('IT Prolet Ltd') + "</a>" : "");
}

/** Whether shipment is editable or read-only. In `Request.vue` the Save button appears if `!shipment.collected && !shipment.cancelled && shipment.owned`. In `Shipments.vue` only `shipment.collected` is loaded. */
export function isShipmentReadonly(shipment) {
  return shipment.collected || shipment.cancelled || (
    typeof shipment.owned !== 'undefined' && !shipment.owned
  );
}

const DEFAULT_ALERT_TIMEOUT = 5000;
const ERROR_ALERT_TIMEOUT  = 20000;
export const msg = {
  type: '',
  text: '',
  time: DEFAULT_ALERT_TIMEOUT,
  show: false,
  popup: (text, type, time) => {
    msg.type = type || 'info';
    msg.time = time !== undefined ? time : (type === 'error' ? ERROR_ALERT_TIMEOUT : DEFAULT_ALERT_TIMEOUT);
    msg.text = text;
    msg.show = true;
  }
}

export const attachmentTypes = [
  {id: 'NUL', color: 'grey'},
  {id: 'MAN', color: 'blue'},
  {id: 'POD', color: 'cyan'},
  {id: 'INS', color: 'green lighten-2'},
  {id: 'COD', color: 'green lighten-2'},// from PUPS
  {id: 'PMT', color: 'green darken-2'},
  {id: 'SIG', color: 'blue lighten-2'},// from PUPS
  {id: 'RQR', color: 'blue darken-2'},// from PUPS
  {id: 'RCP', color: 'cyan'},// from PUPS
  {id: 'DOC', color: 'lime'},// new - Iliyan @ 2025-01-22
  {id: 'OTH', color: 'blue'} //Other documents
];
